export default (authorizedLanguages, language) => {
  const array = authorizedLanguages.filter(lang => lang === language)
  return array.length > 0
}
